import { ContentBody } from 'components/pages/components/ContentBody'
import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RoutePaths } from 'routes/paths'

const SubscriptionManagement: FC = () => {
  const { t } = useTranslation()

  return <ContentBody title={t('subscriptionManagement.title')}></ContentBody>
}

const exportObj = {
  routeProps: {
    // This gets passed straight to react-router
    path: RoutePaths.subscriptionManagement,
    title: 'pages.organizationManagement',
    element: <SubscriptionManagement />,
    roles:
      componentPermissions[componentNames.pageManagementSubscriptionManagement],
    requiresAuthentication: true,
  },
  name: 'SubscriptionManagement',
}
export default exportObj
